import { Onboarding } from "sdk/onboardings";
import { useAppDispatch, useAppSelector } from "~/store/hooks";
import { setOnboarding } from "~/store/onboarding";

interface UseOnboarding extends Partial<Onboarding> {
  handleSetOnboarding: (onboarding: Partial<Onboarding>) => void;
}

export const useOnboarding = (): UseOnboarding => {
  const dispatch = useAppDispatch();
  const { onboarding } = useAppSelector((state) => state.onboarding);

  const handleSetOnboarding = (onboarding: Partial<Onboarding>) => {
    dispatch(setOnboarding(onboarding));
  };

  return {
    handleSetOnboarding,
    ...onboarding,
  };
};
